/* eslint-disable quotes */
import { snakelize, camelize } from '../../../helpers/object'

export default ($axios: any): any => ({
  // 포스팅 평가
  async store(data: any) {
    return camelize(await $axios.post(`/posting/rate`, snakelize(data)))
  },
})
